export var coreBreakpointValues = {
  xxxs: 320,
  xxs: 480,
  xs: 576,
  sm: 768,
  md: 1024,
  mdLg: 1120,
  lg: 1216,
  xl: 1540
};